import { render, staticRenderFns } from "./FxGaleria.vue?vue&type=template&id=ee418baa"
import script from "./FxGaleria.vue?vue&type=script&lang=js"
export * from "./FxGaleria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports